import { tokenPayload } from "../models";
import { jwtDecode } from "jwt-decode";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HomeIcon from '@mui/icons-material/Home';
import { FolderItem } from "../pages/home/types";

const permissions = JSON.parse(localStorage.getItem("user") || '{}')

export const MIDDLEWARE_API_URL = process.env.REACT_APP_MIDDLEWARE_URL;

export const API_URL = process.env.REACT_APP_BASE_URL;
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET;

export const planNames = {
  "SP": "SinglePlay",
  "2P": "DoblePlay",
  "3P": "TriplePlay",
  "2PM": "DoblePlay + Movil",
  "3PM": "TriplePlay + Movil",
  "izzitv+": "izzitv+",
  "DTH": "DTH",
  "Móvil": "Móvil",
  "2P + izzitv+": "DoblePlay + izzitv+"
};

export const sanitize = (input: string) => {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .map(word => {
      const lower = word.toLowerCase();
      return lower[0].toUpperCase() + lower.slice(1);
    })
    .join('')
    .replace(/^./, c => c.toLowerCase());
};

export const sanitizePlays = (input: string) => {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .map(word => {
      const lower = word.toLowerCase();
      return lower;
    })
    .join('');
};

export const verify = async (token: string) => {
    try{
        const response = await fetch(`${MIDDLEWARE_API_URL}/auth/verify/`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        if(response.status === 200){
            const responseBody = response.json()
            if(Object.keys(responseBody).length === 0){
                return true
            } else {
                localStorage.removeItem("jwt");
                localStorage.removeItem("user");
                return false
            }
        }
        return false;
    }
    catch {
        return false;
    }
};

export const decodeJWT = (token: string) => {
    try {
    const decoded = jwtDecode<tokenPayload>(token);
    return decoded;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const addSpaceBeforeCapitalsAndFirstNumber = (str: string) => {
  let result = str.replace(/([A-Z])/g, ' $1');
  result = result.replace(/(\d)/, ' $1');
  return result.trimStart();
};

export const sentActionLog = (event: string, description: string, idPlaza?:string, zipCode?:string, idOferta?: number, idPlay?: number ) => {
  const user = localStorage.getItem("user");
  if (user){
    const token = localStorage.getItem("jwt");
    const userObject = JSON.parse(user);
    const data = {
      usuario: userObject.username,
      evento: event,
      descripcion: description,
      idPlaza,
      idOferta,
      codigoPostal: zipCode,
      idPlay
    }
    fetch(`${API_URL}/log`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `bearer ${token}`,
        "content-type": "application/json",
      },
    })
      .then((res) => res.ok)
      .catch((err) => {
        console.error(err);
      });
  }
};

export const links = [
  {
    label: "Centro de ayuda",
    path: "https://ventasizzi.zendesk.com/hc/es-419",
    isExternal: true,
    icon: SettingsIcon,
    isDisabled: false,
    shouldShow: true
  },
  {
    label: "Catálogo de Productos",
    path: "catalogo-productos",
    isExternal: false,
    icon: FormatListBulletedIcon,
    isDisabled: true,
    shouldShow: true
  },
  {
    label: "Material de apoyo",
    path: "manuales",
    isExternal: false,
    icon: AutoStoriesIcon,
    isDisabled: false,
    shouldShow: true
  },
  {
    label: "Comisiones",
    path: "comisiones",
    isExternal: false,
    icon: LocalAtmIcon,
    isDisabled: true,
    shouldShow: true
  },
  {
    label: "Administrador",
    path: "administrator",
    isExternal: false,
    icon: DashboardIcon,
    isDisabled: false,
    shouldShow: permissions?.administrationAccess
  },
  {
    label: "Home",
    path: "home",
    isExternal: false,
    icon: HomeIcon,
    isDisabled: false,
    shouldShow: permissions?.administrationAccess
  }
];

export const folders: FolderItem[] = [
  {
    title: "Marketplace",
    type: "folder",
    children: [
      {
        title: "wizz",
        type: "folder",
        children: [
          {
            title: "Wizz altas velocidades",
            type: "folder",
            link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ElDZGUyveL5IoYvk4DFLGLUBN9TlCuW4uEolqQJjAOoOsg?e=bxyNja"
          },
          {
            title: "wizz 36 plazas",
            type: "folder",
            link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EvWvGts62OpGrNLkEs52PlwBIImiTvfXqCVBNOIklIT9VA?e=MeFu0U"
          },
          {
            title: "wizz sp",
            type: "folder",
            link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EuE8lLNa1Y9Ntce7IqKUkY8BK85neDQ1u-rmdDw6vq2x1g?e=7v8jNT"
          },
          {
            title: "wizz 10",
            type: "folder",
            link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EgMijyS8HjJBq8ZWgVTnNtEBRQ_bWaZZialpLdGFfx2XGw?e=Ym958T"
          },
          {
            title: "wizz 20",
            type: "folder",
            link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EoRIxdY45ZJHmdEVS_6ekYsBmHtvpdo6ZXOQZyzg3ye37A?e=AkuwZy"
          },
          {
            title: "cambio marca wizz",
            type: "folder",
            children: [
              {
                title: "Linea wizz",
                type: "folder",
                link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ErKOp8G-KexGh35JPnppcwoBSpXpKN23X_uZAnikC9O53A?e=PVoHmX"
              },
              {
                title: "Linea Izzi",
                type: "folder",
                link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EuDof48PM7RBvPS1X9fsdIYBvASs-Kxk2Fl-cQf8dUrgLw?e=JgLk1a"
              }
            ]
          }
        ]
      },
      {
        title: "Izzi Movil",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EpLPrSKiiDZIog0bVjGBlBUBtOm6OHjUr--vhbLKRUo25Q?e=thCqPI"
      },
      {
        title: "Izzi tv+light",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EpgB38Hn01pDkbXV3T8Wf9EBtBgnKd3_CpicPdmuCiolcw?e=8RaszI"
      },
      {
        title: "izzi",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EseI3bYZ45FEjpwEJiqXbzsBTfGjjxd_8R8ohkbuONek5A?e=qrjoPK"
      }
    ]
  },
  {
    title: "Acapulco",
    type: "folder",
    children: [
      {
        title: "2025_C10_flyers_Acapulco_14x21.5cm_V07",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EiJ5wz8-tSNMkWYAoHJH_5wBpGGFgyu44J99NvvW6FnyvA?e=slmY94"
      }
    ]
  },
  {
    title: "Izzi",
    type: "folder",
    children: [
      {
        title: "2025_C10_diptico_nacional_V03",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EutREiaqJs5JvSb5I2rTGXgBupDugi7UEzf9poPbCWYzUw?e=jBIuuq"
      },
      {
        title: "2025_C10_flyer_nacional_DA_14x21.5cm_V03",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ErH92euEl5JBsM2i9bJ8J-sBuorv3IphrDE_uqZ3s0rVAw?e=kL270y"
      }
    ]
  },
  {
    title: "izzi tv+",
    type: "folder",
    children: [
      {
        title: "2025_C10_flyer_izzi_tv_izzi_móvil",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/Em9D-i1JI6xIhAtxNMe6C0sBOgrZzrJr6GdXicICfeB8zg?e=v3eQUJ"
      },
      {
        title: "2025_C10_flyer_izzi_tv+_con_izzi_tv+_light",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ErdskKLcb0lIm2QoekN6JVEB-NKHPugQeyzk6U84ZfYmXw?e=bgsrIr"
      },
      {
        title: "2025_C10_flyer_izzi_tv+_con_izzi_tv+light_DA",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ErNY7de2gEtKvsOX18lQM70BvZHO0fuyqvVbDQIsRY5WNw?e=OsDIS8"
      },
      {
        title: "2025_C10_flyer izzi tv con grilla",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EmtSf2Tnw31LnURigRESWacB8tlA3Y3B_x89aH9kb2F2JQ?e=5ft9bX"
      }
    ]
  },
  {
    title: "Perifoneos",
    type: "folder",
    link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/Et90yFHw7s5LhXlzdUJlr98BPSSHJ-u5dUeXBjsNW9JlfQ?e=3T5Dm9"
  },
  {
    title: "Plazas Especiales",
    type: "folder",
    children: [
      {
        title: "2025_C10_flyer_plazas_especiales_14x21.5cm_V01",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EnrOv2-eJ2tHvbfwtD0PkjoB-N0X4lmVgoJEvGHOAYhhlg?e=cYx3Ad"
      }
    ]
  },
  {
    title: "Barker",
    type: "folder",
    link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/Emby3Mo6UwdBpESCOpZ-CPgBg-raqCxd0SVUq-wykTilzw?e=nu7Idv"
  },
  {
    title: "Reconstrucción",
    type: "folder",
    children: [
      {
        title: "2025_C10_flyer_veracruz_DA_FTTH_14x21.5cm_electrónico",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EsZtCdpkuepGuVWbXiidjvIBKb4ZHTqMk4-2yW1QVrKHew?e=j1Eegk"
      },
      {
        title: "2025_C10_flyer_veracruz_FTTH_14x21.5cm",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/Ei5eYQciicFNjG5rwIeXHjsBPn4t2HtYn1ubVGsBU7QTDQ?e=jSdZb1"
      },
      {
        title: "2025_C10_flyer_Cholula_FTTH_14x21.5cm_V04",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EvHu7pgS63JFsFBLw-ngh04BxzpC3Su-J3YggC2Mo7Bz9A?e=Ba4jbv"
      },
      {
        title: "2025_C10_flyer_Cholula_FTTH_DA_14x21.5cm_electrónico",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EkMB0HPXHpxHi528Gt6SCggBoC1yhaUQlMrtS4ITUBnH5g?e=Vs4XaL"
      },
      {
        title: "2025_C10_flyer_Edomex_DA_FTTH_14x21.5cm_electrónico",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EqV93b8v8ndBnO1B2gBEjEsBTMrS13JmuGr9moO3LeAaBg?e=SloKn9"
      },
      {
        title: "2025_C10_flyer_Edomex_FTTH_14x21.5cm",
        type: "folder",
        link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/EvmeFhcpzWdHkVKf2YRGHvABrbNAVfQqEWyBGJQKwalUWA?e=C3fK1i"
      }
    ]
  },
  {
    title: "Pago Anticipado",
    type: "folder",
    link: "https://izzitelco-my.sharepoint.com/:f:/g/personal/mhvilla_izzi_mx/ErOFKXLSQ1pBlWGzSq8QWr4BSVsaF3ydODt1uCy6_2fcdA?e=PHDZJo",
  }
];

export const colors = ['#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F', '#EDC948']